import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { ButtonLink } from '@fenderdigital/ui/ButtonV2';
import Spacer from '@fenderdigital/ui/Spacer';
import BodyText from '@fenderdigital/ui/BodyText';
import PickIcon from '@fenderdigital/ui/Icons/Skills';
import SongsIcon from '@fenderdigital/ui/Icons/Songs';
import HorizontalRule from '@fenderdigital/ui/HorizontalRule';
import CollectionsIcon from '@fenderdigital/ui/Icons/PlayLists';

import * as S from './NoResults-styled';

interface NoResultsProps {
  query: string;
  onClose: () => void;
}

const NoResults: FC<NoResultsProps> = ({ query, onClose }) => {
  return (
    <S.MetaWrapper>
      <S.ContainerWrapper>
        <S.ErrorContainer style={{ minHeight: '40.625rem' }}>
          <Spacer spacing="lg3" />
          <BodyText
            textSize="f6"
            textColor="black"
            alignment="center"
            css={`
              white-space: break-spaces;
            `}
          >
            {`No matches found for \n`}
            <S.Span>{`"${query}"`}</S.Span>
          </BodyText>
          <Spacer spacing="md3" />
          <BodyText
            textSize="f3"
            textColor="gray"
            alignment="center"
            css={`
              white-space: break-spaces;
            `}
          >
            {`Please check the spelling or try\n a different search term.`}
          </BodyText>
          <Spacer spacing="lg3" />
          <HorizontalRule strokeLength="18.75rem" ariaHidden />
          <Spacer spacing="md4" />
          <BodyText textSize="f3">Can&apos;t find what you&apos;re looking for?</BodyText>
          <Spacer spacing="md1" />
          <S.ErrorButtonContainer>
            <ButtonLink as={Link} to="/search?query=" onClick={onClose}>
              Go to search page
            </ButtonLink>
          </S.ErrorButtonContainer>
          <Spacer spacing="lg1" />
          <BodyText textSize="f3">Or browse by:</BodyText>
          <Spacer spacing="md2" />
          <S.ErrorCategoryContainer>
            <S.ErrorContainer>
              <S.SectionLink to="/guitar/songs" onClick={onClose}>
                <S.LogoContainer>
                  <SongsIcon style={{ fill: 'black' }} width="1.2em" height="1.2em" aria-hidden />
                </S.LogoContainer>
                <Spacer spacing="md1" />
                <BodyText fontFamily="sourceSansBold" textSize="f3" id="songs">
                  Songs
                </BodyText>
              </S.SectionLink>
            </S.ErrorContainer>
            <Spacer spacing="md3" direction="vertical" />
            <S.ErrorContainer>
              <S.SectionLink to="/guitar/skills" onClick={onClose}>
                <S.LogoContainer>
                  <PickIcon style={{ fill: 'black' }} width="1.2em" height="1.2em" aria-hidden />
                </S.LogoContainer>
                <Spacer spacing="md1" />
                <BodyText fontFamily="sourceSansBold" textSize="f3">
                  Skills
                </BodyText>
              </S.SectionLink>
            </S.ErrorContainer>
            <Spacer spacing="md3" direction="vertical" />
            <S.ErrorContainer>
              <S.SectionLink to="/guitar/collections" onClick={onClose}>
                <S.LogoContainer>
                  <CollectionsIcon
                    style={{ fill: 'black' }}
                    width="1.2em"
                    height="1.2em"
                    aria-hidden
                  />
                </S.LogoContainer>
                <Spacer spacing="md1" />
                <BodyText fontFamily="sourceSansBold" textSize="f3">
                  Collections
                </BodyText>
              </S.SectionLink>
            </S.ErrorContainer>
          </S.ErrorCategoryContainer>
        </S.ErrorContainer>
      </S.ContainerWrapper>
    </S.MetaWrapper>
  );
};

export default NoResults;
